export const forums = {
  forumsSearchInputPlaceholder: 'Zoeken',
  forumsFollowDiscussionButtonTitle: 'Volgen',
  forumsFollowingDiscussButtonTitle: 'Volgend',
  forumDiscussionInfoNoReplyText: 'Nog geen antwoorden',
  forumsDiscussionDetailsStartButtonTitle: 'Start discussie',
  forumDetailsCreatedByText: 'door',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Kopieer link',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Meld inhoud',
  forumsReportedCurtainContent: 'Inhoud gemeld',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Link gekopieerd!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Discussie vastpinnen',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Discussie losmaken',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Bewerk discussie',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Verwijder discussie',
  forumsDiscussionDetailspPopupDeleteTitle: 'Verwijderen',
  forumsDiscussionDetailspPopupDeleteText: 'Deze discussie verwijderen?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Annuleren',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Bevestigen',
  forumsDiscussionDetailsDeleledAlertText: 'Discussie verwijderd!',
  forumsNewDiscussionTitle: 'Nieuwe discussie',
  forumsNewDiscussionTitlePlaceholder: 'Titel...',
  forumsNewDiscussionBodyPlaceholderText: 'Plaats hier uw tekst...',
  forumsNewDiscussionPublishButtonTitle: 'Publiceren',
  forumsNewDiscussionLocationCurtainTitle: 'Locatie',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Locatienaam',
  forumsNewDiscussionEditLocationCurtainText: 'Locatie bewerken',
  forumsNewDiscussionDeleteLocationCurtainText: 'Locatie verwijderen',
  forumsNewDiscussionCreatePollTitle: 'Maak poll',
  forumsNewDiscussionTitleInputPlaceholder: 'Titel',
  forumsNewDiscussionOptionInputPlaceholder: 'Optie',
  forumsNewDiscussionAddButtonTitle: 'Optie toevoegen',
  forumsNewDiscussionCreateButtonTitle: 'Creëren',
  forumsNewDiscussionPollTitleBlankAlertText: 'Titel mag niet leeg zijn!',
  forumsNewDiscussionPollOptionBlankAlertText: 'Optie mag niet leeg zijn!',
  forumsNewDiscussionPollLongTitleAlertText: 'Titel mag maximaal 140 tekens bevatten',
  forumsNewDiscussionPollLongOptionAlertText: 'Optie mag maximaal 50 tekens bevatten',
  forumsNewDiscussionEditPollIconText: 'Bewerk poll',
  forumsNewDiscussionRemovePollIconText: 'Verwijder poll',
  forumsDiscardDraftPopupTitle: 'Concept verwijderen',
  forumsDiscardDraftPopupText: 'Dit concept verwijderen?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Annuleren',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Bevestigen',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Antwoord',
  forumsDiscussionDetailsNoCommentsText: 'Er zijn nog geen opmerkingen\nU kunt de eerste zijn',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Antwoord',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Kopieer link',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Link gekopieerd!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Meld inhoud',
  forumsDiscussionDetailsPostCurtainReportedText: 'Inhoud gemeld',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Antwoord',
  forumsEditDiscussionTitle: 'Bewerk discussie',
  forumsEditDiscussionSaveButtonTitle: 'Opslaan',
  forumsEditedDiscussionSavedAlertText: 'Discussie opgeslagen!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Bewerk antwoord',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Verwijder antwoord',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Opmerking opgeslagen!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Opmerking verwijderd!',
  forumsAlertSomethinWrong: 'Er is iets misgegaan!',
  forumsMaxMbSize: 'U kunt maximaal {size} MB tegelijk uploaden',
  forumsMaxAttachments: 'U heeft het maximale aantal bijlagen overschreden. Maximaal aantal bijlagen is {max}',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Verwijderen',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Deze opmerking verwijderen?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Annuleren',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Bevestigen',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Meld inhoud',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Inhoud gemeld',
  forumDiscussionInfoLastReplyText: 'Laatste antwoord',
  forumsDiscussionAt: 'op',
  forumsDiscussionDetailsFlagCurtainTitle: 'Melden',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Inhoud gemeld',
  forumsPollInfoVotesText: 'stemmen',
  forumsPollInfoEditVoteText: 'Bewerk stem',
  forumsPollFinishPollText: 'Beëindig de poll',
  forumsPollFinishedPollText: 'Voltooid',
  forumsPollInProgresslText: 'Bezig',
  forumsPollCurtainTitle: 'Beëindig de poll',
  forumsPollCurtainText: 'Gebruikers kunnen niet meer stemmen nadat de poll is beëindigd.',
  forumsFinishPollCurtainCancelButtonTitle: 'Annuleren',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Bevestigen',
  forumsPollInfoPollVotesCurtainTitle: 'Poll-stemmen'
}
